// Update Team.jsx to add video testimonials and link to detail pages

import React, { useState, useEffect } from 'react'
import { Users, Star, Quote, Play } from 'lucide-react'
import { Link } from 'react-router-dom'

const Team = () => {
  const [selectedDepartment, setSelectedDepartment] = useState('all')
  const [teamMembers, setTeamMembers] = useState([])
  const [testimonials, setTestimonials] = useState([])

  // ...existing code for departments, sampleTeamMembers, sampleTestimonials...

  const departments = [
    { id: 'all', name: 'All Team' },
    { id: 'actors', name: 'Actors' },
    { id: 'directors', name: 'Directors' },
    { id: 'production', name: 'Production' },
    { id: 'technical', name: 'Technical Crew' }
  ]

  const sampleTeamMembers = [
    {
      id: 1,
      name: 'Rafiqul Islam',
      role: 'Lead Actor',
      department: 'actors',
      bio: 'Award-winning actor with 15 years of experience in Bangladeshi cinema and television drama.',
      image: 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=400',
      projects: 'Shadows of Dhaka, Eternal Bonds, City Lights'
    },
    {
      id: 2,
      name: 'Nusrat Jahan',
      role: 'Lead Actress',
      department: 'actors',
      bio: 'Versatile actress known for powerful performances in both contemporary and traditional roles.',
      image: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=400',
      projects: 'The River\'s Song, Shadows of Dhaka, Monsoon Melodies'
    },
    {
      id: 3,
      name: 'Kamal Hossain',
      role: 'Director & Founder',
      department: 'directors',
      bio: 'Visionary filmmaker dedicated to showcasing Bangladeshi culture through compelling storytelling.',
      image: 'https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=400',
      projects: 'All Shikdar Films Productions'
    },
    {
      id: 4,
      name: 'Sadia Rahman',
      role: 'Producer',
      department: 'production',
      bio: 'Experienced producer with expertise in managing complex film and drama productions.',
      image: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=400',
      projects: 'Eternal Bonds, Voices of Heritage'
    },
    {
      id: 5,
      name: 'Tanvir Ahmed',
      role: 'Director of Photography',
      department: 'technical',
      bio: 'Master cinematographer specializing in visual storytelling and cultural authenticity.',
      image: 'https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=400',
      projects: 'Eternal Bonds (Best Cinematography Award), The River\'s Song'
    },
    {
      id: 6,
      name: 'Farhan Khan',
      role: 'Supporting Actor',
      department: 'actors',
      bio: 'Character actor bringing depth and authenticity to every role.',
      image: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=400',
      projects: 'City Lights, Shadows of Dhaka'
    },
    {
      id: 7,
      name: 'Ayesha Sultana',
      role: 'Production Designer',
      department: 'production',
      bio: 'Creative designer crafting authentic Bangladeshi sets and visual environments.',
      image: 'https://images.pexels.com/photos/1181690/pexels-photo-1181690.jpeg?auto=compress&cs=tinysrgb&w=400',
      projects: 'Shadows of Dhaka, Voices of Heritage'
    },
    {
      id: 8,
      name: 'Imran Chowdhury',
      role: 'Sound Designer',
      department: 'technical',
      bio: 'Award-nominated sound designer creating immersive audio experiences.',
      image: 'https://images.pexels.com/photos/1438081/pexels-photo-1438081.jpeg?auto=compress&cs=tinysrgb&w=400',
      projects: 'Monsoon Melodies, The River\'s Song'
    }
  ]

  const sampleTestimonials = [
    {
      id: 1,
      name: 'Rafiqul Islam',
      role: 'Lead Actor',
      image: 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=400',
      quote: 'Working with Shikdar Films has been the highlight of my career. Their commitment to authentic storytelling and cultural representation is unmatched in the industry.',
      type: 'text',
      videoUrl: null
    },
    {
      id: 2,
      name: 'Dr. Anwar Hossain',
      role: 'Director, Bangladesh International Film Festival',
      image: 'https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=400',
      quote: 'Shikdar Films consistently delivers exceptional work that elevates Bangladeshi cinema on the international stage.',
      type: 'video',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      thumbnail: 'https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=400'
    },
    {
      id: 3,
      name: 'Nusrat Jahan',
      role: 'Lead Actress',
      image: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=400',
      quote: 'The creative freedom and professional environment at Shikdar Films allows actors to truly embody their characters.',
      type: 'text',
      videoUrl: null
    },
    {
      id: 4,
      name: 'Sarah Mitchell',
      role: 'International Film Critic',
      image: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=400',
      quote: 'Shikdar Films brings a fresh perspective to South Asian cinema with beautiful balance of tradition and contemporary storytelling.',
      type: 'video',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      thumbnail: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=400'
    },
    {
      id: 5,
      name: 'Tanvir Ahmed',
      role: 'Director of Photography',
      image: 'https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=400',
      quote: 'As a cinematographer, I appreciate how Shikdar Films values visual storytelling and gives us creative space to create stunning imagery.',
      type: 'text',
      videoUrl: null
    }
  ]

  useEffect(() => {
    const savedTeam = localStorage.getItem('shikdar_films_team')
    const savedTestimonials = localStorage.getItem('shikdar_films_testimonials')
    
    if (savedTeam) {
      setTeamMembers(JSON.parse(savedTeam))
    } else {
      setTeamMembers(sampleTeamMembers)
      localStorage.setItem('shikdar_films_team', JSON.stringify(sampleTeamMembers))
    }

    if (savedTestimonials) {
      setTestimonials(JSON.parse(savedTestimonials))
    } else {
      setTestimonials(sampleTestimonials)
      localStorage.setItem('shikdar_films_testimonials', JSON.stringify(sampleTestimonials))
    }
  }, [])

  const filteredMembers = selectedDepartment === 'all' 
    ? teamMembers 
    : teamMembers.filter(member => member.department === selectedDepartment)

  const handleImageError = (e) => {
    e.target.src = 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=400'
  }

  return (
    <div className="min-h-screen bg-gray-50 py-16" data-component-path="client/src/pages/Team.jsx" data-component-line="1:1" data-component-id="client/src/pages/Team.jsx:1:1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Team.jsx" data-component-line="2:2" data-component-id="client/src/pages/Team.jsx:2:2">
        <div className="text-center mb-12" data-component-path="client/src/pages/Team.jsx" data-component-line="3:3" data-component-id="client/src/pages/Team.jsx:3:3">
          <div className="flex items-center justify-center gap-3 mb-4" data-component-path="client/src/pages/Team.jsx" data-component-line="4:4" data-component-id="client/src/pages/Team.jsx:4:4">
            <Users className="w-12 h-12 text-bengal-green" data-component-path="client/src/pages/Team.jsx" data-component-line="5:5" data-component-id="client/src/pages/Team.jsx:5:5" />
            <h1 className="section-title text-4xl md:text-5xl text-gray-900" data-component-path="client/src/pages/Team.jsx" data-component-line="6:5" data-component-id="client/src/pages/Team.jsx:6:5">Our Team</h1>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-component-path="client/src/pages/Team.jsx" data-component-line="8:4" data-component-id="client/src/pages/Team.jsx:8:4">
            Meet the talented actors and dedicated production staff behind Shikdar Films
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12" data-component-path="client/src/pages/Team.jsx" data-component-line="13:3" data-component-id="client/src/pages/Team.jsx:13:3">
          {departments.map((dept) => (
            <button
              key={dept.id}
              onClick={() => setSelectedDepartment(dept.id)}
              className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                selectedDepartment === dept.id
                  ? 'bg-bengal-green text-white shadow-md'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
              data-component-path="client/src/pages/Team.jsx" data-component-line="15:6" data-component-id="client/src/pages/Team.jsx:15:6"
            >
              {dept.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20" data-component-path="client/src/pages/Team.jsx" data-component-line="28:3" data-component-id="client/src/pages/Team.jsx:28:3">
          {filteredMembers.map((member) => (
            <Link 
              key={member.id}
              to={`/team/${member.id}`}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
              data-component-path="client/src/pages/Team.jsx" data-component-line="30:6" data-component-id="client/src/pages/Team.jsx:30:6"
            >
              <div className="relative h-64 overflow-hidden" data-component-path="client/src/pages/Team.jsx" data-component-line="35:7" data-component-id="client/src/pages/Team.jsx:35:7">
                <img 
                  src={member.image}
                  alt={member.name}
                  onError={handleImageError}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  data-component-path="client/src/pages/Team.jsx" data-component-line="36:8" data-component-id="client/src/pages/Team.jsx:36:8"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" data-component-path="client/src/pages/Team.jsx" data-component-line="43:8" data-component-id="client/src/pages/Team.jsx:43:8"></div>
                <div className="absolute bottom-4 left-4 right-4" data-component-path="client/src/pages/Team.jsx" data-component-line="44:8" data-component-id="client/src/pages/Team.jsx:44:8">
                  <h3 className="text-white font-bold text-lg mb-1" data-component-path="client/src/pages/Team.jsx" data-component-line="45:9" data-component-id="client/src/pages/Team.jsx:45:9">{member.name}</h3>
                  <p className="text-bengal-orange text-sm font-medium" data-component-path="client/src/pages/Team.jsx" data-component-line="46:9" data-component-id="client/src/pages/Team.jsx:46:9">{member.role}</p>
                </div>
              </div>

              <div className="p-6" data-component-path="client/src/pages/Team.jsx" data-component-line="50:7" data-component-id="client/src/pages/Team.jsx:50:7">
                <p className="text-gray-600 text-sm leading-relaxed mb-4" data-component-path="client/src/pages/Team.jsx" data-component-line="51:8" data-component-id="client/src/pages/Team.jsx:51:8">
                  {member.bio}
                </p>
                <div className="pt-4 border-t border-gray-200" data-component-path="client/src/pages/Team.jsx" data-component-line="54:8" data-component-id="client/src/pages/Team.jsx:54:8">
                  <p className="text-xs text-gray-500 font-medium mb-1" data-component-path="client/src/pages/Team.jsx" data-component-line="55:9" data-component-id="client/src/pages/Team.jsx:55:9">Notable Projects:</p>
                  <p className="text-sm text-gray-700" data-component-path="client/src/pages/Team.jsx" data-component-line="56:9" data-component-id="client/src/pages/Team.jsx:56:9">{member.projects}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Testimonials Section with Video Support */}
        <div className="bg-gradient-to-br from-bengal-green to-bengal-orange rounded-2xl p-8 md:p-12 mb-12" data-component-path="client/src/pages/Team.jsx" data-component-line="64:3" data-component-id="client/src/pages/Team.jsx:64:3">
          <div className="text-center mb-12" data-component-path="client/src/pages/Team.jsx" data-component-line="65:4" data-component-id="client/src/pages/Team.jsx:65:4">
            <div className="flex items-center justify-center gap-3 mb-4" data-component-path="client/src/pages/Team.jsx" data-component-line="66:5" data-component-id="client/src/pages/Team.jsx:66:5">
              <Star className="w-10 h-10 text-white" data-component-path="client/src/pages/Team.jsx" data-component-line="67:6" data-component-id="client/src/pages/Team.jsx:67:6" />
              <h2 className="section-title text-3xl md:text-4xl text-white" data-component-path="client/src/pages/Team.jsx" data-component-line="68:6" data-component-id="client/src/pages/Team.jsx:68:6">What People Say</h2>
            </div>
            <p className="text-lg text-white/90 max-w-2xl mx-auto" data-component-path="client/src/pages/Team.jsx" data-component-line="70:5" data-component-id="client/src/pages/Team.jsx:70:5">
              Testimonials from actors, festival directors, and collaborators
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-component-path="client/src/pages/Team.jsx" data-component-line="75:4" data-component-id="client/src/pages/Team.jsx:75:4">
            {testimonials.map((testimonial) => (
              <div 
                key={testimonial.id}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300"
                data-component-path="client/src/pages/Team.jsx" data-component-line="77:7" data-component-id="client/src/pages/Team.jsx:77:7"
              >
                {testimonial.type === 'video' ? (
                  <div className="mb-4" data-component-path="client/src/pages/Team.jsx" data-component-line="82:8" data-component-id="client/src/pages/Team.jsx:82:8">
                    <div className="relative aspect-video rounded-lg overflow-hidden" data-component-path="client/src/pages/Team.jsx" data-component-line="83:9" data-component-id="client/src/pages/Team.jsx:83:9">
                      <iframe
                        src={testimonial.videoUrl}
                        title={`${testimonial.name} testimonial`}
                        className="w-full h-full"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        loading="lazy"
                        data-component-path="client/src/pages/Team.jsx" data-component-line="84:10" data-component-id="client/src/pages/Team.jsx:84:10"
                      ></iframe>
                    </div>
                  </div>
                ) : (
                  <>
                    <Quote className="w-10 h-10 text-bengal-orange mb-4" data-component-path="client/src/pages/Team.jsx" data-component-line="95:10" data-component-id="client/src/pages/Team.jsx:95:10" />
                    <p className="text-gray-700 leading-relaxed mb-6 italic" data-component-path="client/src/pages/Team.jsx" data-component-line="96:10" data-component-id="client/src/pages/Team.jsx:96:10">
                      "{testimonial.quote}"
                    </p>
                  </>
                )}
                <div className="flex items-center gap-4" data-component-path="client/src/pages/Team.jsx" data-component-line="101:8" data-component-id="client/src/pages/Team.jsx:101:8">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    onError={handleImageError}
                    className="w-12 h-12 rounded-full object-cover"
                    loading="lazy"
                    data-component-path="client/src/pages/Team.jsx" data-component-line="102:9" data-component-id="client/src/pages/Team.jsx:102:9"
                  />
                  <div data-component-path="client/src/pages/Team.jsx" data-component-line="109:9" data-component-id="client/src/pages/Team.jsx:109:9">
                    <p className="font-semibold text-gray-900" data-component-path="client/src/pages/Team.jsx" data-component-line="110:10" data-component-id="client/src/pages/Team.jsx:110:10">{testimonial.name}</p>
                    <p className="text-sm text-gray-600" data-component-path="client/src/pages/Team.jsx" data-component-line="111:10" data-component-id="client/src/pages/Team.jsx:111:10">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Team